import Vue from 'vue'
import Router from 'vue-router'
import Layout from 'pages/Layout'

import CmpPjHome from 'pages/cmpProjs/home/Home'
import CmpActProj from 'pages/cmpProjs/actProj/ActProj'
import CmpProjCreate from 'pages/cmpProjs/projCreate/ProjCreate'
import CmpProjGraph from 'pages/cmpProjs/projGraph'
import CmpLangGraph from 'pages/cmpProjs/langGraph'

import ApplyHome from 'pages/applies/applyHome/ApplyHome'
import Apply from 'pages/applies/apply/Apply'
import ApplyStatus from 'pages/applies/applyStatus/ApplyStatus'
import ApplyStatusDetail from 'pages/applies/applyStatusDetail/ApplyStatusDetail'
import Contract from 'pages/applies/contract/Contract'
import ContractCreate from 'pages/applies/contractCreate/ContractCreate'
import ApplyDetail from 'pages/applies/detail/Detail'
import EnterPlan from 'pages/applies/enterPlan/EnterPlan'
import EnterDetail from 'pages/applies/enterDetail/EnterDetail'
import WorkStatus from 'pages/applies/workStatus/WorkStatus'
import IntvPlace from 'pages/applies/intvPlace/IntvPlace'

import InviteHome from 'pages/invites/inviteHome/InviteHome'
import PointInfo from 'pages/invites/pointInfo/PointInfo'
import ExchangeInfo from 'pages/invites/exchangeInfo/ExchangeInfo'
import ExchangeMonth from 'pages/invites/exchangeMonth/ExchangeMonth'
import InviteSearch from 'pages/invites/inviteSearch/InviteSearch'
import CompanyDetail from 'pages/invites/companyDetail/CompanyDetail'
import InviteCode from 'pages/invites/inviteCode/InviteCode'
import InviteCodeSales from 'pages/invites/inviteCodeSales'
import TechLevel from 'pages/invites/techLevel/TechLevel'
import TechDetail from 'pages/invites/techDetail/TechDetail'
import TechChild from 'pages/invites/techChild/TechChild'
import MakePoint from 'pages/invites/makePoint/MakePoint'
import TechResume from 'pages/invites/techResume/TechResume'
import TechResumeCreate from 'pages/invites/techResumeCreate/TechResumeCreate'

import SettingHome from 'pages/setting/settingHome/SettingHome'
import PostalUpload from 'pages/setting/postalUpload/PostalUpload'
import SysMail from 'pages/setting/sysMail/SysMail'
import SysMailGroup from 'pages/setting/sysMailGroup/SysMailGroup'

import UserOptHis from 'pages/setting/userOptHis/UserOptHis'
import ShareAccessHis from 'pages/setting/shareAccessHis/ShareAccessHis'

import HttpError from 'pages/httpError/HttpError'

Vue.use(Router)

export default new Router({
    mode:'history',
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
     },
    routes:[
        {
            path: '/',
            name: 'Layout',
            component: Layout,
            children:[
                {
                    // ログイン画面表示
                    path: 'login',
                },
                {
                    // URL送信画面：http://tech.local/password/reset
                    // 新password設定画面：http://tech.local/password/reset/64b26c2ce11b74eae9031615e713e3f8c2c6a3b69d092da7a41bf58a5004eafe
                    path: 'password/reset/:revision?',
                },
                {
                    path: 'admin/projs/home',
                    name: 'CmpPjHome',
                    component: CmpPjHome,
                    meta: {
                        title: '案件ホーム',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/projs/home/act/:do',
                    name: 'CmpActProj',
                    component: CmpActProj,
                    meta: {
                        title: '応募中案件',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/projs/home/graph/proj',
                    name: 'CmpProjGraph',
                    component: CmpProjGraph,
                    meta: {
                        title: '案件分析(会社)',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/projs/home/graph/lang',
                    name: 'CmpLangGraph',
                    component: CmpLangGraph,
                    meta: {
                        title: '案件分析(言語)',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/projs/home/:do/:id?',
                    name: 'CmpProjCreate',
                    component: CmpProjCreate,
                    meta: {
                        title: '新規案件入力/案件詳細',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/apply',
                    name: 'ApplyHome',
                    component: ApplyHome,
                    meta: {
                        title: '応募ホーム',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/apply/request',
                    name: 'Apply',
                    component: Apply,
                    meta: {
                        title: '応募一覧',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/apply/status',
                    name: 'ApplyStatus',
                    component: ApplyStatus,
                    meta: {
                        title: '応募状況',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/apply/status/:id',
                    name: 'ApplyStatusDetail',
                    component: ApplyStatusDetail,
                    meta: {
                        title: '応募状況詳細',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/apply/contract',
                    name: 'Contract',
                    component: Contract,
                    meta: {
                        title: '契約情報',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/apply/contract/do/:do/:id?',
                    name: 'ContractCreate',
                    component: ContractCreate,
                    meta: {
                        title: '契約入力/案件詳細',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/apply/request/:id',
                    name: 'ApplyDetail',
                    component: ApplyDetail,
                    meta: {
                        title: '応募詳細',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/apply/enter',
                    name: 'EnterPlan',
                    component: EnterPlan,
                    meta: {
                        title: '入場日程',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/apply/enter/:day',
                    name: 'EnterDetail',
                    component: EnterDetail,
                    meta: {
                        title: '入場日程詳細',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/apply/work/:do',
                    name: 'WorkStatus',
                    component: WorkStatus,
                    meta: {
                        title: '現場中/更新待ち/退場待ち/退場済み',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/apply/place',
                    name: 'IntvPlace',
                    component: IntvPlace,
                    meta: {
                        title: '場所(面接/入場)',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/invites',
                    name: 'InviteHome',
                    component: InviteHome,
                    meta: {
                        title: '招待',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/invites/search/:id',
                    name: 'InviteSearch',
                    component: InviteSearch,
                    meta: {
                        title: '法人検索',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/invites/company/detail/:group',
                    name: 'CompanyDetail',
                    component: CompanyDetail,
                    meta: {
                        title: '法人詳細',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/invites/code/:type/:group',
                    name: 'InviteCode',
                    component: InviteCode,
                    meta: {
                        title: '招待コード',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/invites/sales',
                    name: 'InviteCodeSales',
                    component: InviteCodeSales,
                    meta: {
                        title: '個人営業招待',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/invites/tech/level',
                    name: 'TechLevel',
                    component: TechLevel,
                    meta: {
                        title: '個人Level一覧',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/invites/tech/detail/:userId/:name',
                    name: 'TechDetail',
                    component: TechDetail,
                    meta: {
                        title: '個人詳細画面',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/invites/tech/child/:code/:name/:level',
                    name: 'TechChild',
                    component: TechChild,
                    meta: {
                        title: '個人友だち一覧',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/invites/point/hist',
                    name: 'PointInfo',
                    component: PointInfo,
                    meta: {
                        title: 'ポイント情報',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/invites/point/exchange',
                    name: 'ExchangeInfo',
                    component: ExchangeInfo,
                    meta: {
                        title: '換金情報',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/invites/point/exchange/month/:month',
                    name: 'ExchangeMonth',
                    component: ExchangeMonth,
                    meta: {
                        title: '換金情報(月)',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/invites/point/make',
                    name: 'MakePoint',
                    component: MakePoint,
                    meta: {
                        title: 'ポイント発行',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/invites/tech/resume',
                    name: 'TechResume',
                    component: TechResume,
                    meta: {
                        title: '履歴書一覧',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/invites/tech/resume/:do/:id?',
                    name: 'TechResumeCreate',
                    component: TechResumeCreate,
                    meta: {
                        title: '履歴書入力/詳細/編集',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/setting',
                    name: 'SettingHome',
                    component: SettingHome,
                    meta: {
                        title: '各種設定',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/setting/postal/upload',
                    name: 'PostalUpload',
                    component: PostalUpload,
                    meta: {
                        title: '郵便番号upload',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/setting/sys/mail',
                    name: 'SysMail',
                    component: SysMail,
                    meta: {
                        title: 'システム通知送信',
                        keepAlive: true
                    }
                },
                {
                    path: 'admin/setting/sys/mail/group/:type/:group',
                    name: 'SysMailGroup',
                    component: SysMailGroup,
                    meta: {
                        title: '送信グループ詳細',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/setting/user/opt/his',
                    name: 'UserOptHis',
                    component: UserOptHis,
                    meta: {
                        title: 'ユーザー操作追跡',
                        keepAlive: false
                    }
                },
                {
                    path: 'admin/setting/share/access/his',
                    name: 'ShareAccessHis',
                    component: ShareAccessHis,
                    meta: {
                        title: 'シェア情報閲覧履歴',
                        keepAlive: false
                    }
                },
            ]
        },
        {
            path: '/error/:status?',
            name: 'HttpError',
            component: HttpError
        },
        {
            path: '*',
            redirect: {
                name: 'HttpError',
            }
        }
     ]
});
